<template>
  <div id="google_btn"></div>
</template>

<script>
import { defineComponent, useMeta, watch, ref } from '@nuxtjs/composition-api';
import { useAuth } from '~/modules/auth/state/useAuth';
import { useDialog } from '~/composables/useModal';
import { useDevice } from '~/composables/useDevice';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';
export default defineComponent({
  head: {},
  setup() {
    const { loginWithGoogle } = useAuth();
    const { openErrorDialog } = useDialog();
    const { isMobile } = useDevice();
    const { sendAuthEvent } = onedioEvents();
    const isGSILoaded = ref(false);

    useMeta(() => {
      return {
        script: [
          {
            hid: 'gsi',
            src: 'https://accounts.google.com/gsi/client',
            async: true,
            callback: () => {
              isGSILoaded.value = true;
            },
          },
        ],
      };
    });

    const handleGoogleOTL = async (response) => {
      sendAuthEvent('Login Actions', 'Login Clicked', 'Google');
      try {
        await loginWithGoogle(response.credential);
        sendAuthEvent('Login Actions', 'Login Success', 'Google');
        location.reload(true);
      } catch (error) {
        sendAuthEvent('Login Actions', 'Login Error', 'Google');
        openErrorDialog({ error, description: error?.response?.data?.message });
      }
    };

    watch(isGSILoaded, (isGSILoadedNew) => {
      if (isGSILoadedNew) {
        /* eslint-disable-next-line */
        google.accounts?.id?.initialize({
          client_id: '262942824570-0pceelihhj609sk8mndnsldm5ufnk4im.apps.googleusercontent.com',
          callback: handleGoogleOTL,
          ui_mode: isMobile.value ? 'bottom_sheet' : 'card',
        });
        /* eslint-disable-next-line */
        google.accounts?.id?.prompt();
        // Login Button Example
        // google?.accounts?.id?.renderButton(document.getElementById('google_btn'), {
        //   type: 'standard',
        //   shape: 'pill',
        //   theme: 'filled_blue',
        //   text: 'continue_with',
        //   size: 'large',
        //   locale: LANG,
        // });
      }
    });
    return {};
  },
});
</script>
